<div class="assessment-component">

  <div *ngIf="rows" style="width: 100%;">
    <p-table [value]="rows"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             #table
             dataKey="id"
             [columns]="columns"
    >
      <ng-template pTemplate="caption">

        <div class="ui-helper-clearfix flex flex-row justify-content-end">
          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-file-excel"
                  iconPos="left"
                  (click)="table.exportCSV()"
          >
          </button>
          <div style="display: flex; flex-direction: row; float: right;margin: 0 10px;">
            <div><span
              style="display:inline-block; width: 14px;height: 14px;background-color:#CBDFB8;margin: 0 0 0 5px;"></span>
              Completed
            </div>
            <div><span
              style="display:inline-block; width: 14px;height: 14px;background-color:#EAB18B;margin: 0 0 0 5px;"></span>
              Not Completed
            </div>
            <div><span
              style="display:inline-block; width: 14px;height: 14px;background-color:#adaaaa;margin: 0 0 0 5px;"></span>
              Not Assigned
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr style="white-space: nowrap; font-weight: bold;">
          <th style="width: 20em;">User Name</th>
          <th>Form Identifier</th>
          <th>Completed</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr>
          <td [ngStyle]="{fontWeight: item.bold ? 'bold' : 'normal'}">
            {{item.name}}
          </td>
          <td>
            {{item.completionName}}
          </td>
          <td>
            {{item.completed}}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
